import PropTypes from 'prop-types';
import InterferometryPointsTooltip from './InterferometryPointsTooltip';

const VectorMapTooltip = ({layer}) => {
	const layerKey = layer?.sourceLayer?.props?.layerKey;
	const style = layer?.layer?.props?.options?.style?.rules[0]?.styles[1];
	const attributeKey = style?.attributeKey;
	switch (layerKey) {
		case 'zones':
			return null;
		case 'interferometryPoints':
			return (
				<InterferometryPointsTooltip
					layer={layer.layer}
					object={layer.object}
					attributeKey={attributeKey}
				/>
			);
		default:
			return null;
	}
};

VectorMapTooltip.propTypes = {
	layer: PropTypes.object,
};

export default VectorMapTooltip;
